function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "collection-arrow",
  transform: "translate(-1.000000, -7.000000)",
  fill: "#DB6453"
}, React.createElement("path", {
  d: "M24.2699807,13 L20,8.47597098 L21.3930873,7 L28,14 L21.3930873,21 L20,19.524029 L24.2699807,15 L1,15 L1,13 L24.2699807,13 Z",
  id: "Combined-Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "27px",
    height: "14px",
    viewBox: "0 0 27 14",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/collection-arrow.be03b122.svg";
export { SvgComponent as ReactComponent };